import React, { useMemo, useEffect, useState } from "react"
import {
  UncontrolledTooltip,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Col,
  Row,
  Label,
  Card,
  CardBody,
  CardTitle,
  Badge,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import TableContainer from '../../../components/Common/TableContainer';
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import Select from "react-select";

import InputMask from "react-input-mask";

import { Link } from "react-router-dom";

import { useFormik } from "formik"
import * as Yup from "yup";

const Batch = () => {
  //meta title
  //meta title
  document.title = "NattoLabs - Painel Adminitrativo";

  const [modalAddBatch, setModalAddBatch] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [batch, setBatch] = useState(null);
  const [batchList, setBatchList] = useState([{ id: 1, code: "108", head_amount: 25000,date_placement:"08/09/2023",date_slaught:"08/10/2023",farm_name:"Granja Agrestina",aviary_code:"01" }]);


  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      id: (batch && batch.id) || '',
      code: (batch && batch.code) || '',
      name: (batch && batch.name) || '',
    },
    validationSchema: Yup.object({
      code: Yup.string().required("Por favor digite a Código"),
      name: Yup.string().required("Por favor digite o Nome"),

    }),
    onSubmit: (values) => {

      if (isEdit) {
        const updateOrder = {
          batch_id: batch ? batch.id : 0,
          name: values.name,
          code: values.code,
        };



      } else {

        const newOrder = {
          id: batchList.length + 1,
          name: values["name"],
          code: values["code"],
        };

        addBatchToTable(newOrder);
        validation.resetForm();

        // save new order
      }

    },
  });

  const handleOrderClick = arg => {

    setIsEdit(true);

    setBatch({ id: arg.id, name: arg.name, code: arg.code });

    toggleModalAddBatch();



  };

  const handleOrderClicks = () => {

    setIsEdit(false);
    toggleModalAddBatch();


  };


  function toggleModalAddBatch() {
    if (modalAddBatch) {
      setModalAddBatch(false);
      setBatch(null);
    } else {
      setModalAddBatch(true)
    }

  }



  const addBatchToTable = (value) => {
    const modifiedRows = [...batchList];

    modifiedRows.push(value);
    setBatchList(modifiedRows);

    toggleModalAddBatch();
  }

  const columns = useMemo(
    () => [
      {
        Header: 'Id',
        accessor: 'id',
        disableFilters: true,

      },
      {
        Header: 'Código',
        accessor: 'code',
        disableFilters: true,
      },
      {
        Header: 'Quantidade Alojadas',
        accessor: 'head_amount',
        disableFilters: true,
      },
      {
        Header: 'Data de Alojamento',
        accessor: 'date_placement',
        disableFilters: true,
      },
      {
        Header: 'Data Final Prevista',
        accessor: 'date_slaught',
        disableFilters: true,
      },
      {
        Header: 'Granja',
        accessor: 'farm_name',
        disableFilters: true,
      },
      {
        Header: 'Núcleo',
        accessor: 'core_code',
        disableFilters: true,
      },
      {
        Header: 'Aviáio',
        accessor: 'aviary_code',
        disableFilters: true,
      },
      {
        Header: 'Status',
        accessor: 'status',
        disableFilters: true,
        Cell: (cellProps) => {
          return (
            <Badge
            className={"font-size-12 bg-success"}
          >
           ATIVO
          </Badge>);
        }
      },
      {
        Header: 'Mortalidade',
        accessor: 'mortality',
        disableFilters: true,
        Cell: (cellProps) => {
          return (
            <Badge
            className={"font-size-12 badge-soft-success"}
            pill
          >
            0.35 %
          </Badge>);
        }
      },
      {
        Header: 'Ações',
        accessor: 'action',
        disableFilters: true,
        Cell: (cellProps) => {
          return (
            <UncontrolledDropdown direction="start">
              <DropdownToggle
                href="#"
                className="card-drop"
                tag="i"
              >
                <i className="mdi mdi-dots-horizontal font-size-18" />
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-end">

                <DropdownItem
                  href={"/epbatchdetail/"}
                >
                  <i className="mdi mdi-eye font-size-16 text-danger me-1" />{" "}
                  Ver Detalhes
                </DropdownItem>

                <DropdownItem
                  onClick={() => {
                    const batchData = cellProps.row.original;
                    handleOrderClick(batchData);
                  }}
                >
                  <i className="mdi mdi-head-sync-outline font-size-16 text-danger me-1" />{" "}
                  Replanejar
                </DropdownItem>



                <DropdownItem
                  href={"#"}
                >
                  <i className="mdi mdi-file-excel-box font-size-16 text-danger me-1" />{" "}
                  Cancelar
                </DropdownItem>

                <DropdownItem
                  href={"#"}
                >
                  <i className="mdi mdi-cancel font-size-16 text-danger me-1" />{" "}
                  Desabilitar
                </DropdownItem>

              </DropdownMenu>

            </UncontrolledDropdown>
          );
        }
      },
    ],
    []
  );


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Produção de Frango" breadcrumbItem="Listagem de Lotes" />
          <TableContainer
            columns={columns}
            data={batchList}
            isGlobalFilter={true}
            customPageSize={10}
            isAddOptions={true}
            customPageSizeOptions={2}
            handleOrderClicks={handleOrderClicks}
          //className="custom-header-css"
          />

          <Modal
            size="lg"
            isOpen={modalAddBatch}
            toggle={() => {
              toggleModalAddBatch();
            }}
          >
            <ModalHeader toggle={toggleModalAddBatch} tag="h4">
              {!!isEdit ? "Editar Lote" : "Adicionar Lote"}
            </ModalHeader>

            <ModalBody>
              <Form
                onSubmit={validation.handleSubmit}
              >
                <Row>
                  <Col className="col-12">
                    <div className="mb-3">
                      <Label className="form-label">Quantidade de Aves</Label>

                      <Input
                        type="number"
                        defaultValue="0"
                        id="example-date-input"
                      />

                    </div>


                    <div className="mb-3">
                      <Label className="form-label">Código</Label>
                      <Input
                        name="code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.code || ""}
                        invalid={
                          validation.touched.code && validation.errors.code ? true : false
                        }
                      />
                      {validation.touched.code && validation.errors.code ? (
                        <FormFeedback type="invalid">{validation.errors.code}</FormFeedback>
                      ) : null}
                    </div>


                    <div className="mb-3">
                      <Label className="form-label">Data de Alojamento</Label>

                      <Input
                        type="date"
                        defaultValue="2019-08-19"
                        id="example-date-input"
                      />

                    </div>

                    <div className="mb-3">
                      <Label className="form-label">Duração</Label>

                      <Input
                        type="number"
                        defaultValue="1"
                        id="example-date-input"
                      />

                    </div>

                    <div className="mb-3">
                      <Label className="form-label">Granja</Label>
                      <Input
                        name="farm_id"
                        type="select"
                        className="form-select"
                        onChange={e => {
                          getSystemByArea(e.target.value)
                        }}
                      >
                        <option value="">Selecione...</option>
                        {/* {(farm || []).map((row, key) => (
                                <option key={key} value={row.id}>{row.name}</option>
                                ))} */}
                      </Input>

                    </div>


                    <div className="mb-3">
                      <Label className="form-label">Núcleo</Label>
                      <Input
                        name="farm_id"
                        type="select"
                        className="form-select"
                        onChange={e => {
                          getSystemByArea(e.target.value)
                        }}
                      >
                        <option value="">Selecione...</option>
                        {/* {(farm || []).map((row, key) => (
                                <option key={key} value={row.id}>{row.name}</option>
                                ))} */}
                      </Input>

                    </div>

                    <div className="mb-3">
                      <Label className="form-label">Aviário</Label>
                      <Input
                        name="aviary_id"
                        type="select"
                        className="form-select"
                        onChange={e => {
                          getSystemByArea(e.target.value)
                        }}
                      >
                        <option value="">Selecione...</option>
                        {/* {(aviary || []).map((row, key) => (
                                <option key={key} value={row.id}>{row.name}</option>
                                ))} */}
                      </Input>

                    </div>
                  </Col>

                </Row>

                <Row>
                  <Col>
                    <div className="text-end">
                      <button
                        type="submit"
                        className="btn btn-success save-user"
                      >
                        Salvar
                      </button>
                    </div>
                  </Col>
                </Row>

              </Form>
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Batch;
